<template>
  <div v-if="isVisible" style="width: 100%; height: 50vh" class="text-center mt-lg-3 d-flex flex-column align-items-center justify-content-center">
    <div class="loading-container">
      <div class="custom-timed-progress-bar" :style="{ width: progress + '%' }">
      </div>
    </div>
    <h5 class="mt-3" v-if="progress < 100 && !isLoaderReachedLimit">
      Loading, please wait...
    </h5>

    <transition name="longWaitingMessage">
      <h5 class="mt-3" v-if="progress < 100 && isLoaderReachedLimit">
        It's taking a bit longer, stay with us...
      </h5>
    </transition>

  </div>
</template>

<script>
export default {
  props: {
    durationInSeconds: Number,
    isVisible: Boolean
  },
  data() {
    return {
      progress: 0,
      intervalId: null,
      startTime: null,
      maxValueBeforeLoadingComplete: 95
    };
  },
  methods: {
    startLoading() {
      this.progress = 0;
      this.startTime = Date.now();

      this.intervalId = setInterval(() => {
        const durationInMilliseconds = (this.durationInSeconds * 1000);
        const timeElapsedSinceLoadingStart = Date.now() - this.startTime;

        const updatedProgress = (timeElapsedSinceLoadingStart / durationInMilliseconds) * 100;

        if(updatedProgress && !isNaN(updatedProgress)) {
          this.progress = Math.min(updatedProgress, this.maxValueBeforeLoadingComplete);
        }

      }, 100);
    },
    completeLoading() {
      clearInterval(this.intervalId);
      this.intervalId = undefined;

      this.$nextTick(() => {
        setTimeout(() => {
          this.progress = 100;
        }, 100); // delay a bit to ensure transition kicks in
      });
    },
  },
  computed: {
    isLoaderReachedLimit() {
      return this.progress >= this.maxValueBeforeLoadingComplete;
    }
  },
  created() {
    this.startLoading();
  },
  watch: {
    isVisible(val) {
      if(val === false) {
        this.completeLoading();
      }
    }
  },
  beforeDestroy() {
    if(this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
};
</script>


<style scoped>
.loading-container {
  height: 8px;
  background-color: #e0e0e0;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  width: 300px;
}

.custom-timed-progress-bar {
  height: 8px;
  background: linear-gradient(to right, #FFAA00, #9CB828 68.6%, #51C346 86.3%, #07CE64 100%);
  transition: width 0.5s ease-out;
}

.longWaitingMessage-enter-active, .longWaitingMessage-leave-active {
  transition: all 3s ease;
}

.longWaitingMessage-enter, .longWaitingMessage-leave-to {
  opacity: 0;
}
</style>
